<script>
export default {
  data: function () {
    return {
      sortKey: 'convertedDate',
      sortDirection: 'ASC', // ASC/DESC
      localStoragePrefix: ''
    }
  },
  computed: {
    sortedEvents() {
      const sorted = [...this.convertedEvents]
      sorted.sort(this.sortEvents)
      return sorted
    }
  },
  created(){
    const sortKey = localStorage.getItem(this.localStoragePrefix + 'contract_events_sort_key')
    const sortDirection = localStorage.getItem(this.localStoragePrefix + 'contract_events_sort_direction')
    if(sortKey !== undefined) this.sortKey = sortKey
    if(sortDirection !== undefined) this.sortDirection = sortDirection
  },
  methods: {
    sortEventsByKey(key) {
      if(key !== this.sortKey) {
        this.sortKey = key
        this.sortDirection = 'ASC'
        localStorage.setItem(this.localStoragePrefix + 'contract_events_sort_key', this.sortKey)
        localStorage.setItem(this.localStoragePrefix + 'contract_events_sort_direction', this.sortDirection)
        return
      }

      if(this.sortDirection === 'ASC') this.sortDirection = 'DESC'
      else this.sortDirection = 'ASC'
      localStorage.setItem(this.localStoragePrefix + 'contract_events_sort_direction', this.sortDirection)
    },
    tableHeaderClass(key) {
      let classes = 'b-full-table__header-cell_sortable'
      if(this.sortKey !== key) return classes
      if(this.sortDirection === 'ASC') classes += ' b-full-table__header-cell_sorted-asc'
      if(this.sortDirection === 'DESC') classes += ' b-full-table__header-cell_sorted-desc'
      return classes
    },
    sortEvents(e1, e2) {
      if(this.sortKey === 'convertedDate') return this.sortByDate(e1, e2)
      if(this.sortDirection === 'ASC') return e1[this.sortKey] < e2[this.sortKey] ? -1 : 1
      if(this.sortDirection === 'DESC') return e1[this.sortKey] < e2[this.sortKey] ? 1 : -1
      return 0
    },
    sortByDate(e1, e2) {
      if(e1[this.sortKey] === e2[this.sortKey]) return 0
      if(this.sortDirection === 'ASC') return new Date(e1[this.sortKey]) < new Date(e1[this.sortKey]) ? -1 : 1
      if(this.sortDirection === 'DESC') return new Date(e1[this.sortKey]) < new Date(e1[this.sortKey]) ? 1 : -1
    },
    eventIndex(event) {
      return this.convertedEvents.indexOf(event)
    }
  }
}
</script>
